// extracted by mini-css-extract-plugin
export default {"blogContent":"BlogContent_blogContent__aHYsr"};